/** Server lifecycle: new=1, active=2, inactive=3, archived=4 */

const STATUS_STRING_TO_INT = {
  new: 1,
  active: 2,
  inactive: 3,
  archived: 4,
};

const STATUS_INT_TO_STRING = {
  1: "new",
  2: "active",
  3: "inactive",
  4: "archived",
};

const ALLOWED = new Set(["new", "active", "inactive", "archived"]);

/**
 * API write: status as integer (VAT / Sales tax permit per backend contract).
 */
export function taxSettingStatusToApiInt(raw) {
  if (raw == null || String(raw).trim() === "") return 1;
  if (typeof raw === "number" && Number.isFinite(raw)) {
    const n = Math.trunc(raw);
    if (n >= 1 && n <= 4) return n;
  }
  const s = String(raw).trim().toLowerCase();
  if (s === "deactivated") return STATUS_STRING_TO_INT.inactive;
  if (ALLOWED.has(s)) return STATUS_STRING_TO_INT[s];
  const parsed = parseInt(String(raw), 10);
  if (!Number.isNaN(parsed) && parsed >= 1 && parsed <= 4) return parsed;
  return 1;
}

/**
 * UI / selects: normalize API or legacy string to lowercase lifecycle key.
 */
export function taxSettingStatusToUiString(raw) {
  if (raw == null || String(raw).trim() === "") return "new";
  if (typeof raw === "number" && Number.isFinite(raw)) {
    const n = Math.trunc(raw);
    if (STATUS_INT_TO_STRING[n]) return STATUS_INT_TO_STRING[n];
  }
  const trimmed = String(raw).trim();
  const asNum = parseInt(trimmed, 10);
  if (!Number.isNaN(asNum) && STATUS_INT_TO_STRING[asNum]) {
    return STATUS_INT_TO_STRING[asNum];
  }
  const k = trimmed.toLowerCase();
  if (ALLOWED.has(k)) return k;
  return "new";
}
